angular.module('impactx.orderconfirmation').controller('OrderConfirmationCtrl', [
    '$scope',
    'dataGen',
    '$mdToast',
    'BackService',
    'ToolbarService',
    'AppConfiguration',
    OrderConfirmationCtrl
]);

function OrderConfirmationCtrl($scope, dataGen, $mdToast, BackService, ToolbarService, AppConfiguration) {
    var self = this;
    $scope.selectedItems = [];
    $scope.selectedDiscountItems = [];
    $scope.showConfirmationData = {value: false};
    var alsoShowDateWarningOnEarlyDates = AppConfiguration.get('checkEarlyDateOnOrderConfirmation');

    self.changeItemDates = function () {
        var newValue = $scope.data.expectedDeliveryDate.dateValue;
        if (newValue) {
            var items = $scope.data.items;
            var i;
            for (i = 0; i < items.length; i++) {
                items[i].changed.deliveryDate.dateValue = newValue;
            }
        }
    };

    self.toggleConfirmationData = function () {
        $scope.showConfirmationData.value = !$scope.showConfirmationData.value;
    };

    self.closeConfirmation = function () {
        var dataObj = {
            cnh: $scope.data
        };
        return dataGen.postAsForm($scope, dataObj, "/orderconfirmation/close").then(function () {
            BackService.back();
            $mdToast.show(
                $mdToast.simple()
                    .textContent($scope.trns.success)
                    .position("bottom right")
                    .hideDelay(10000)
            );
        });
    };

    self.selectDiscountItem = function (item, event) {
        if (event.target.tagName != "SPAN" && event.target.tagName != "INPUT" && (event.target.parentNode == null || event.target.parentNode.tagName != "BUTTON")
            && event.target.tagName != "BUTTON" && event.target.tagName != "TEXTAREA"
            && event.target.getAttribute("role") != "button") {
            if ($scope.selectedItems) {
                for (var i = 0; i < $scope.selectedItems.length; i++) {
                    $scope.selectedItems[i].selected = false;
                }
                $scope.selectedItems.splice(0, 1);
            }
            if (item.selected) {
                var index = $scope.selectedDiscountItems.indexOf(item);
                if (index > -1) {
                    $scope.selectedDiscountItems.splice(index, 1);
                }
            }
            else {
                $scope.selectedDiscountItems.push(item);
            }
            item.selected = !item.selected;
        }
    };

    self.removeDiscounts = function () {
        while ($scope.selectedDiscountItems.length > 0) {
            if (!$scope.data.adHoc.removed) {
                $scope.data.adHoc.removed = [];
            }

            $scope.data.adHoc.removed.push($scope.selectedDiscountItems[0].id);
            $scope.data.adHoc.adHocItems.splice($scope.data.adHoc.adHocItems.indexOf($scope.selectedDiscountItems[0]), 1);
            $scope.selectedDiscountItems.splice(0, 1);
        }
    };
    self.addDiscount = function () {
        var newAdHocItem = {};
        newAdHocItem.name = {};
        newAdHocItem.id = 0;
        newAdHocItem.type = {id: 1};
        newAdHocItem.supplierNo = {};
        newAdHocItem.price = {};
        newAdHocItem.price.netValue = {};
        newAdHocItem.price.netValue.value = 0;
        newAdHocItem.price.currency = {};
        newAdHocItem.price.currency.selected = $scope.data.currencies.selected;
        newAdHocItem.price.taxRate = {};
        newAdHocItem.price.taxRate.selected = $scope.data.taxRates.selected;
        $scope.data.adHoc.adHocItems.push(newAdHocItem);
    };

    self.differ = function (value1, value2) {
        return Math.abs(value1 - value2) > Math.pow(10, -8);
    };

    self.defineButtons = function() {
        var buttonDefinition = [
            {
                label: $scope.trns.close,
                action: self.closeConfirmation,
                type: 'validation',
                condition: canClose,
                params: {
                    form: $scope.dialogData
                }
            },
            {
                label: $scope.trns.addDiscount,
                action: self.addDiscount,
                type: 'dialogaction',
                condition: canAddDiscount
            },
            {
                label: $scope.trns.change,
                action: self.toggleConfirmationData,
                type: 'dialogaction',
                condition: canToggleConfirmationDate
            },
            {
                label: $scope.trns.removeDiscounts,
                action: self.removeDiscounts,
                type: 'dialogaction',
                condition: canRemoveDiscounts
            },
            {
                label: $scope.trns.print,
                type: 'print',
                condition: canPrint,
                params: {
                    printToken: $scope.printTokens.confirmation
                }
            }
        ];
        ToolbarService.setButtons(buttonDefinition);
    };

    self.showDateWarning = function(actualDateValue, expectedDateProperty, dateType) {
        if (actualDateValue && expectedDateProperty) {
            var expectedDateValue = expectedDateProperty.dateValue;
            if (expectedDateValue) {
                var actualDate = startOfDay(actualDateValue);
                var expectedDate = startOfDay(expectedDateValue);
                if (dateType === 'expected') {
                    if (!alsoShowDateWarningOnEarlyDates) {
                        return actualDate.getTime() > expectedDate.getTime();
                    }
                    // return actualDate.getTime() !== expectedDate.getTime();
                }
                else if (dateType === 'first') {
                    return actualDate.getTime() < expectedDate.getTime();
                }
                else if (dateType === 'last') {
                    return actualDate.getTime() > expectedDate.getTime();
                }
                // else if(dateType === 'desired')
                return actualDate.getTime() !== expectedDate.getTime();
            }
        }
    };

    function startOfDay(dateValue) {
        var date = new Date(dateValue);
        date.setHours(0);
        date.setMinutes(0);
        date.setSeconds(0);
        date.setMilliseconds(0);
        return date;
    }

    function canClose() {
        return !$scope.data.isClosed;
    }

    function canAddDiscount() {
        return canClose() && $scope.data.allowAdHocConditions;
    }

    function canToggleConfirmationDate() {
        return canClose() && $scope.selectedItems.length > 0;
    }

    function canRemoveDiscounts() {
        return canAddDiscount() && $scope.selectedDiscountItems.length > 0;
    }

    function canPrint() {
        return !$scope.data.notExistingAndNoEdit;
    }
}